var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component.tag,_vm._b({tag:"component",staticClass:"link-1"},'component',_vm.component.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }